
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import StatsGrid from './StatsGrid';
import BookingChart from './BookingChart';
import RevenueChart from './RevenueChart';
import RecentBookings from './RecentBookings';
import TopPlayers from './TopPlayers';

const Dashboard = ({ user, onLogout }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    return (
        <div id="admin-container" className="flex">
            {isSidebarOpen && <div className="fixed inset-0 bg-black opacity-50 z-30 lg:hidden" onClick={toggleSidebar}></div>}
            <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <main id="main-content" className={`flex-1 lg:ml-64 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'lg:ml-64' : 'lg:ml-0'}`}>
                <Header user={user} onLogout={onLogout} toggleSidebar={toggleSidebar} title="Dasbor" />
            </main>
        </div>
    );
};

export default Dashboard;
